import React, { useEffect, useState } from "react";
import HelmetSeo from "../../components/Site/Reusable/HelmetSeo";
import Hero from "../../components/Site/Reusable/Hero";
import { useSelector } from "react-redux";
import { fetchQaListItems, fetchSeoListItems } from "../../actions/Site/global";
import { useDispatch } from "react-redux";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import BlockInfoDescription from "../../components/Site/Reusable/BlockInfoDescription";
import ContactFormLanding from "../../components/Site/Reusable/ContactFormLanding";
import SpacingItem from "../../components/Site/Reusable/SpacingItem";
import RelatedServicesLanding from "../../components/Site/Reusable/RelatedServicesLanding";
import RelatedServicesImageLandingSmartFish from "../../components/Site/Reusable/RelatedServicesImageLandingSmartFish";
import BlockItemTitleWithImageBlock from "../../components/Site/Reusable/BlockItemTitleWithImageBlock";
import BlockItemTitleWithImageBlockSmartFish from "../../components/Site/Reusable/BlockItemTitleWithImageBlockSmartFish";
import TitleDescriptionLanding from "../../components/Site/Reusable/TitleDescriptionLanding";
import ExapandList from "../../components/Site/Sections/SOC/ExapandList";
import RelatedServicesImageLanding from "../../components/Site/Reusable/RelatedServicesImageLanding";

const SmartFish = () => {
  const { dataPagesListQa, dataPagesListSeo } = useSelector(
    (state) => state.globalReducer
  );

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18next.language);
  const [startLang, setStartLang] = useState(0);

  useEffect(() => {
    dispatch(fetchQaListItems(6));
    dispatch(fetchSeoListItems(21));

    const languageChangeHandler = (newLanguage) => {
      setCurrentLanguage(newLanguage);
    };

    // Pretplatite se na događaj promene jezika
    i18next.on("languageChanged", languageChangeHandler);

    setStartLang(1);

    // Očistite pretplatu kada se komponenta odmontira
    return () => {
      i18next.off("languageChanged", languageChangeHandler);
    };
  }, [dispatch]);

  useEffect(() => {
    if (startLang > 0) dispatch(fetchQaListItems(6));
  }, [currentLanguage]);

  return (
    <div className="penetration-testing-holder-main smart-fish-holder-main">
      <HelmetSeo
        title={dataPagesListSeo.length > 0 && dataPagesListSeo[0].acTitle}
        description={
          dataPagesListSeo.length > 0 && dataPagesListSeo[0].acDescription
        }
        keywords={dataPagesListSeo.length > 0 && dataPagesListSeo[0].acKeywords}
      />
      <Hero
        title={t("smartFishLandingPage.hero.title")}
        description={t("smartFishLandingPage.hero.desc")}
        img={`smartfish.png`}
      />
      <SpacingItem />
      <ContactFormLanding
        t={t}
        title={t("smartFishLandingPage.contactForm.title")}
        phone={t("smartFishLandingPage.contactForm.phone")}
        desc={t("smartFishLandingPage.contactForm.desc")}
        type={`Smart Fish landing stranica`}
        isEmail={true}
        emailText={t("smartFishLandingPage.contactForm.emailText")}
      />
      <BlockInfoDescription text={t("smartFishLandingPage.hero.desc")} />
      <RelatedServicesLanding
        t={t}
        paddingTop={true}
        colorSpecific={"purple"}
        key1={t("smartFishLandingPage.threeItemsPercetange.key1")}
        key2={t("smartFishLandingPage.threeItemsPercetange.key2")}
        key3={t("smartFishLandingPage.threeItemsPercetange.key3")}
        value1={t("smartFishLandingPage.threeItemsPercetange.value1")}
        value2={t("smartFishLandingPage.threeItemsPercetange.value2")}
        value3={t("smartFishLandingPage.threeItemsPercetange.value3")}
      />
      <RelatedServicesImageLandingSmartFish
        image={`bckg-25.png`}
        title={t("smartFishLandingPage.threeItemsPercetange2.title")}
        desc={t("smartFishLandingPage.threeItemsPercetange2.desc")}
        desc2={t("smartFishLandingPage.threeItemsPercetange2.desc2")}
        key1={t("smartFishLandingPage.threeItemsPercetange2.key1")}
        key2={t("smartFishLandingPage.threeItemsPercetange2.key2")}
        key3={t("smartFishLandingPage.threeItemsPercetange2.key3")}
        value1={t("smartFishLandingPage.threeItemsPercetange2.value1")}
        value2={t("smartFishLandingPage.threeItemsPercetange2.value2")}
        value3={t("smartFishLandingPage.threeItemsPercetange2.value3")}
      />
      <BlockItemTitleWithImageBlock
        image={`images/image-block-12.png`}
        number={`1.`}
        title={t("smartFishLandingPage.titleDescBlock.title")}
        title2={t("smartFishLandingPage.imageTextTitleBlock.title2")}
        title3={t("smartFishLandingPage.imageTextTitleBlock.title3")}
        btn={t("smartFishLandingPage.imageTextTitleBlock.btn")}
        link={`/documents/pen-test-en.pdf`}
      />
      <BlockItemTitleWithImageBlockSmartFish
        image={`images/image-block-12.png`}
        imageShow={0}
        number={`2.`}
        title={t("smartFishLandingPage.titleDescBlock2.title")}
        desc={t("smartFishLandingPage.titleDescBlock2.desc")}
        list1={t("smartFishLandingPage.imageTextTitleBlock2.list1")}
        list2={t("smartFishLandingPage.imageTextTitleBlock2.list2")}
        list3={t("smartFishLandingPage.imageTextTitleBlock2.list3")}
        btn={t("smartFishLandingPage.imageTextTitleBlock2.btn")}
        link={
          currentLanguage === "sr"
            ? "/documents/smartfish-sr.ppsx"
            : "/documents/smartfish-en.ppsx"
        }
      />
      <div className="special-related-services-holder-smart-fish">
        <RelatedServicesImageLanding
          image={`bckg-25.svg`}
          title={t("smartFishLandingPage.threeItemsPercetange3.title")}
          key1={t("smartFishLandingPage.threeItemsPercetange3.key1")}
          key2={t("smartFishLandingPage.threeItemsPercetange3.key2")}
          key3={t("smartFishLandingPage.threeItemsPercetange3.key3")}
          value1={t("smartFishLandingPage.threeItemsPercetange3.value1")}
          value2={t("smartFishLandingPage.threeItemsPercetange3.value2")}
          value3={t("smartFishLandingPage.threeItemsPercetange3.value3")}
        />
      </div>
      <div className="special-big-image-with-text-block-holder">
        <div className="special-big-image-with-text-block">
          <div className="special-big-image-with-text-block-content">
            <h2>{t("smartFishLandingPage.specialText")}</h2>
          </div>
        </div>
      </div>
      <BlockItemTitleWithImageBlock
        image={`images/image-block-13.png`}
        number={`3.`}
        title={t("smartFishLandingPage.titleDescBlock3.title")}
        title3={t("smartFishLandingPage.imageTextTitleBlock3.title3")}
        btn={t("smartFishLandingPage.imageTextTitleBlock3.btn")}
        link={
          currentLanguage === "sr"
            ? "/documents/pen-testing-sr.pdf"
            : "/documents/pen-testing-en.pdf"
        }
      />
      <TitleDescriptionLanding title={t("smartFishLandingPage.faq-title")} />
      <ExapandList dataList={dataPagesListQa} />
    </div>
  );
};

export default SmartFish;
